/**
 * マイコレクションの「ダウンロード」を、再生ではなく保存にする。
 *
 * なぜ要るか（2026-10-01）:
 *   ボタンは <a href="https://cdn.shopify.com/…mp3" download> だが、
 *   **download 属性は同一オリジンのリンクにしか効かない**（HTML 仕様）。
 *   ストアは store.ultralmtm.com、ファイルは cdn.shopify.com で別オリジン。
 *   Shopify の CDN は Content-Disposition を返さないので、素のままだと
 *   ブラウザが mp3 を開いて **再生してしまう**（実機で確認済み）。
 *
 * やっていること:
 *   fetch でファイルを読み、blob: の URL を作ってから download 属性付きで開く。
 *   blob: は**同一オリジン扱い**なので download が効き、ファイル名も指定できる。
 *   Shopify の CDN は access-control-allow-origin: * を返すので fetch できる
 *   （2026-10-01 に OPTIONS / GET 両方で確認）。
 *
 * 落ちたときは素のリンクとして開く。つまり**今までの挙動に戻るだけ**で、
 * 「押しても何も起きない」にはならない。
 */
(function () {
  'use strict';

  var SEL = '.mypage-item__dl';
  var BUSY = 'is-downloading';

  // 使えない環境（古い端末）は何もしない＝素の <a> のまま
  var supported = typeof window.fetch === 'function' &&
    typeof window.URL !== 'undefined' &&
    typeof URL.createObjectURL === 'function' &&
    'download' in document.createElement('a');

  if (!supported) return;

  function fileNameOf(href) {
    try {
      var last = new URL(href, location.href).pathname.split('/').pop();
      return decodeURIComponent(last) || '';
    } catch (e) {
      return '';
    }
  }

  function save(blob, name) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    if (name) a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // revoke が早すぎると保存が始まらない端末があるので少し置く
    setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!a || !a.getAttribute('href')) return;

    // 別タブで開く・保存するなどの操作はユーザーの意図なので邪魔しない
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    // 連打で何本も取りに行かないように
    if (a.classList.contains(BUSY)) { e.preventDefault(); return; }

    var href = a.href;
    e.preventDefault();
    a.classList.add(BUSY);
    a.setAttribute('aria-busy', 'true');

    var done = function () {
      a.classList.remove(BUSY);
      a.removeAttribute('aria-busy');
    };

    fetch(href, { mode: 'cors', credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.blob();
      })
      .then(function (blob) {
        save(blob, fileNameOf(href));
        done();
      })
      .catch(function () {
        // CORS が閉じた・オフライン等。素のリンクとして開く（従来どおり）
        done();
        window.location.href = href;
      });
  }, false);
})();
